import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface UpdateInAppComponentsLogsProps {
  customerId: string;
  body: {
    name: string;
    doNotShowAgain: boolean;
  };
}

export const useUpdateInAppComponent = () =>
  useMutation(
    'useUpdateInAppComponent',
    async ({ customerId, body }: UpdateInAppComponentsLogsProps) => {
      const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/inAppComponentLog`, body);
      return data;
    },
    {
      retry: 1,
    },
  );
